import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TCase, ICaseDeps } from '../../models';

import styles from './styles/styles.css';
import { CaseComponent as Component } from './case';

export const Case = createWidget<ICaseDeps, TCase>({
    styles,
})(Component);
